import React from "react"
import {
	Grid,
	Typography,
	IconButton
} from "@material-ui/core"

import {
	Edit as EditIcon
} from "@material-ui/icons"

import useStyles from "@/pages/Account/Account/Details/components/UserInInstanceCard/style"

type TeamDataProps = {
	id: number
	instanceId?: number
	name: string
}

type UserInInstanceCardProps = {
	name?: string
	status?: string,
	teams?: TeamDataProps[]

	onClickEditButton?: () => void
}

const UserInInstanceCard: React.FC<UserInInstanceCardProps> = (props) => {
	const { name, status, onClickEditButton } = props

	const classes = useStyles()

	return (
		<Grid container justify="space-between" alignItems="center">
			<Grid
				item xs={12} sm={8}
				className={classes.textContainer}
			>
				<Typography
					color="textPrimary"
					variant="h2"
					className={classes.nameText}
				>
					{name}
				</Typography>
			</Grid>

			<Grid item xs={12} sm={2}>
				<Grid container justify="flex-end">
					<IconButton onClick={onClickEditButton} size="small">
						<EditIcon style={{ color: status === "blocked" ? "red" : "" }} />
					</IconButton>
				</Grid>
			</Grid>
		</Grid>
	)
}

export { UserInInstanceCard }
